/**
=========================================================
* Material Dashboard 2  React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";

function configs(labels, datasets) {
  let i = 0;
  let currx;
  let curry;
  return {
    data: {
      labels,
      datasets: [...datasets],
    },

    options: {
      responsive: true,
      maintainAspectRatio: false,
      clip: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              const x = context.raw.x;
              const y = context.raw.y;
              const matchingPoints = datasets[0].data.filter((p) => p.x === x && p.y === y);
              if ((x !== currx && y !== curry) || i >= matchingPoints.length) {
                i = 0;
                currx = x;
                curry = y;
              }

              let lab = matchingPoints[i]?.label;
              i++;
              return lab;
            },
          },
        },
      },
      scales: {
        y: {
          min: 0,
          max: 3,
          title: labels?.y
            ? {
                display: true,
                text: labels?.y, // Y-axis title
                color: "#344767",
                font: {
                  size: 12,
                  family: typography.fontFamily,
                  weight: "bold",
                },
              }
            : {},
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
          },
          ticks: {
            display: true,
            padding: 10,
            color: "#b2b9bf",
            font: {
              size: 11,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
          },
        },
        x: {
          min: 0,
          max: 3,
          title: labels?.x
            ? {
                display: true,
                text: labels?.x, // X-axis title
                color: "#344767",
                font: {
                  size: 12,
                  family: typography.fontFamily,
                  weight: "bold",
                },
              }
            : {},
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
          },
          ticks: {
            display: true,
            color: "#b2b9bf",
            padding: 10,
            font: {
              size: 11,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 1,
            },
          },
        },
      },
    },
  };
}

export default configs;
